import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  section: {
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
    backgroundColor: ({ backgroundColor }) =>
      backgroundColor ? backgroundColor : theme.palette.background.paper,
  },
  sectionContainer: {
    flexDirection: 'column',
    width: '100%',
    minHeight: ({ fullHeight }) => fullHeight && 'calc(100vh - 64px)',
    padding: theme.spacing(4),
    position: 'relative',
    zIndex: 100,
    [theme.breakpoints.up('sm')]: {
      maxWidth: 620,
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(6),
      maxWidth: 1140,
    },
  },
  bg: {
    position: 'absolute !important',
    left: 0,
    top: 0,
    filter: ({ blured }) => (blured ? 'blur(20px)' : 'none'),
    height: '100%',
    width: '100%',
  },
}))
